import { AxiosError } from "axios";

const CHALLENGE_STORAGE_KEY = "truth:cf-confirmed";

function isCloudflareChallengeConfirmed(): boolean {
  return sessionStorage.getItem(CHALLENGE_STORAGE_KEY) === "1";
}

function needsCloudflareChallenge(error: AxiosError): boolean {
  if (isCloudflareChallengeConfirmed()) {
    return false;
  }

  /**
   * Checks if the error is a Cloudflare challenge.
   * This is determined by checking if the response status is 403 (Forbidden)
   * and if the response content type is HTML, which is typical for Cloudflare's challenge
   * page.
   */
  const isForbidden = (error as AxiosError).response?.status === 403;
  const contentType = (error as AxiosError).response?.headers["content-type"];
  const isHtmlResponse =
    typeof contentType === "string" && contentType.includes("text/html");

  return !!isForbidden && !!isHtmlResponse;
}

function handleCloudflareChallenge() {
  sessionStorage.setItem(CHALLENGE_STORAGE_KEY, "1");
  window.location.reload();
}

export {
  CHALLENGE_STORAGE_KEY,
  needsCloudflareChallenge,
  handleCloudflareChallenge,
};
